// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"885":"65a1e923","952":"49e696be"}[chunkId] + ".chunk.js";
};